export default __webpack_public_path__ + "static/media/hht2_ep8_speaking_04.c0166826.png";